import React from "react";
import { Modal } from "antd";
import "./style.css";

const CustomModal = ({
  title,
  visible,
  footer,
  okText,
  cancelText,
  onOk,
  onCancel,
  confirmLoading,
  children,
  ...props
}) => {
  return (
    <div className='custom-modal'>
      <Modal
        className='custom-modal'
        title={title}
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        okText={okText}
        cancelText={cancelText}
        confirmLoading={confirmLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#056333",
            borderColor: "#056333",
          },
        }}
        cancelButtonProps={{
          style: {
            hover: { color: "red" },
          },
        }}
        {...props}
      >
        {children}
      </Modal>
    </div>
  );
};

export default CustomModal;
